"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const useMergeRefs_1 = __importDefault(require("../../../hooks/useMergeRefs"));
require("./Accordion.scss");
const COMPONENT_ID = "monday-accordion";
function defineChildId(index, props, accordionId) {
    if (props.id) {
        return props.id;
    }
    if (accordionId) {
        return `${accordionId}--item-${index}`;
    }
    return `${COMPONENT_ID}--item-${index}`;
}
const Accordion = (0, react_1.forwardRef)(({ children: originalChildren = null, allowMultiple = false, "data-testid": dataTestId = COMPONENT_ID, defaultIndex = [], className = "", id }, ref) => {
    const componentRef = (0, react_1.useRef)(null);
    const mergedRef = (0, useMergeRefs_1.default)({ refs: [ref, componentRef] });
    const [expandedItems, setExpandedItems] = (0, react_1.useState)(defaultIndex);
    const children = (0, react_1.useMemo)(() => react_1.default.Children.toArray(originalChildren), [originalChildren]);
    const isChildExpanded = (0, react_1.useCallback)((itemIndex) => {
        return expandedItems.includes(itemIndex);
    }, [expandedItems]);
    const onChildClick = (0, react_1.useCallback)((itemIndex) => {
        if (allowMultiple) {
            const newExpandedItems = [...expandedItems];
            if (isChildExpanded(itemIndex)) {
                const index = newExpandedItems.indexOf(itemIndex);
                if (index > -1) {
                    newExpandedItems.splice(index, 1);
                }
            }
            else {
                newExpandedItems.push(itemIndex);
            }
            setExpandedItems(newExpandedItems);
            return;
        }
        setExpandedItems([itemIndex]);
    }, [isChildExpanded, expandedItems, allowMultiple]);
    const renderChildElements = (0, react_1.useMemo)(() => {
        return react_1.default.Children.map(children, (child, itemIndex) => {
            const originalProps = Object.assign({}, child === null || child === void 0 ? void 0 : child.props);
            const childId = defineChildId(itemIndex, originalProps, id);
            return react_1.default.cloneElement(child, Object.assign(Object.assign({}, originalProps), { id: childId, onClickAccordionCallback: () => {
                    onChildClick(itemIndex);
                }, open: isChildExpanded(itemIndex) }));
        });
    }, [children, id, isChildExpanded, onChildClick]);
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ ref: mergedRef, className: (0, classnames_1.default)("accordion", className), "data-testid": dataTestId, id: id }, { children: children && renderChildElements })));
});
exports.default = Accordion;
